import MenuBookIcon from '@mui/icons-material/MenuBook'
import ArticleIcon from '@mui/icons-material/Article'
import PolicyIcon from '@mui/icons-material/Policy'
import SchoolIcon from '@mui/icons-material/School'
import PlayArrowIcon from '@mui/icons-material/PlayArrow'
import PodcastsIcon from '@mui/icons-material/Podcasts'
import BookIcon from '@mui/icons-material/Book'
import CodeIcon from '@mui/icons-material/Code'
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts'
import BookmarkIcon from '@mui/icons-material/Bookmark'
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings'
import InfoIcon from '@mui/icons-material/Info'
import HomeIcon from '@mui/icons-material/Home'
import RecommendIcon from '@mui/icons-material/Recommend'
import SmartToyIcon from '@mui/icons-material/SmartToy'
import ExploreIcon from '@mui/icons-material/Explore'

// routes for the whole site (all routes in PAGES the other consts just make things more convienent)

export const PAGES = {
    home: {
        desktop_title: 'T-CAIREM AI Learning Hub',
        mobile_title: 'AI Learning Hub',
        dropdown_mobile_title: 'Home',
        path: '/'
    },
    about: {
        title: 'About',
        path: '/about/'
    },
    start: {
        title: 'Start Here',
        path: '/start-here/'
    },
    resources: {
        title: 'Resources',
    },
    login: {
        title: 'Login',
        path: '/login/'
    },
    profile: {
        title: 'Profile',
        path: '/profile/'
    },
    books: {
        title: 'Books',
        path: '/books/'
    },
    policies: {
        title: 'Policy',
        path: '/policies/'
    },
    courses: {
        title: 'Courses',
        path: '/courses/'
    },
    papers: {
        title: 'Papers',
        path: '/papers/'
    },
    podcasts: {
        title: 'Podcasts',
        path: '/podcasts/'
    },
    videos: {
        title: 'Videos',
        path: '/videos/'
    },
    codenotebooks: {
        title: 'Code Notebooks',
        path: '/codenotebooks/'
    },
    terminology: {
        title: 'Living Glossary',
        path: '/terminology/'
    },
    suggest_term: {
        title: 'Suggest a Term',
        path: '/suggest-term/'
    },
    favourites: {
        title: 'Favourites',
        path: '/favourites/'
    },
    create_resource: {
        title: 'Create Resource',
        path: '/create-resource/'
    },
    forgot_password: {
        title: 'Forgot Password',
        path: '/forgot-password/'
    },
    confirm_forgot_password: {
        title: 'Set New Password',
        path: '/confirm-forgot-password/'
    },
    sign_up: {
        title: 'Sign Up',
        path: '/sign-up/'
    },
    activate: {
        title: 'Activate Account',
        path: '/activate/'
    },
    confirm_email: {
        title: 'Confirm Email',
        path: '/confirm-email/'
    },
    admin_portal: {
        title: 'Admin Portal',
        path: '/admin-portal/'
    },
    manage_resources: {
        title: 'Manage Current Resources',
        path: '/manage-resources/'
    },
    manage_admin: {
        title: 'Manage Admin',
        path: '/manage-admin/'
    },
    manage_tags: {
        title: 'Manage Resource Tags',
        path: '/manage-tags/'
    },
    manage_automation: {
        title: 'Automation',
        path: '/automation/'
    },
    terminology_admin: {
        title: 'Glossary Admin',
        path: '/terminology-admin/'
    },
    quiz: {
        title: 'Take the Quiz',
        path: '/quiz/'
    },
    recommended: {
        title: 'Recommend me Resources',
        path: '/recommended/'
    },
    tcairemResources: {
        title: "T-CAIREM's Resources",
        path: '/tcairem-resources/'
    },
    attributionRules: {
        title: 'Attribution Rules',
        path: '/attribution-rules/'
    },
    chatbot: {
        title: 'AI Learning Assistant',
        path: '/chatbot/'
    },
}

export const RESOURCES = [
    {
        title: PAGES.books.title,
        path: PAGES.books.path,
        icon: MenuBookIcon
    },
    {
        title: PAGES.courses.title,
        path: PAGES.courses.path,
        icon: SchoolIcon
    },
    {
        title: PAGES.papers.title,
        path: PAGES.papers.path,
        icon: ArticleIcon
    },
    {
        title: PAGES.policies.title,
        path: PAGES.policies.path,
        icon: PolicyIcon
    },
    {
        title: PAGES.podcasts.title,
        path: PAGES.podcasts.path,
        icon: PodcastsIcon
    },
    {
        title: PAGES.videos.title,
        path: PAGES.videos.path,
        icon: PlayArrowIcon
    },
    {
        title: PAGES.codenotebooks.title,
        path: PAGES.codenotebooks.path,
        icon: CodeIcon
    },
    {
        title: PAGES.terminology.title,
        path: PAGES.terminology.path,
        icon: BookIcon
    },
]

export const SETTINGS = [
    {
        title: PAGES.profile.title,
        path: PAGES.profile.path,
        icon: ManageAccountsIcon
    },
    {
        title: PAGES.favourites.title,
        path: PAGES.favourites.path,
        icon: BookmarkIcon
    },
]

export const MOBILE_NAV_ROUTES = [
    {
        mobile_title: PAGES.home.mobile_title,
        title: PAGES.home.dropdown_mobile_title,
        path: PAGES.home.path,
        icon: HomeIcon,
        user: false,
        staff: false
    },
    {
        title: PAGES.about.title,
        path: PAGES.about.path,
        icon: InfoIcon,
        user: false,
        staff: false
    },
    {
        title: PAGES.start.title,
        path: PAGES.start.path,
        icon: ExploreIcon,
        user: false,
        staff: false
    },
    {
        title: PAGES.resources.title,
        icon: ArticleIcon,
        children: RESOURCES,
        user: false,
        staff: false
    },
    {
        title: PAGES.tcairemResources.title,
        path: PAGES.tcairemResources.path,
        icon: SchoolIcon,
        user: false,
        staff: false
    },
    {
        title: PAGES.profile.title,
        path: PAGES.profile.path,
        icon: ManageAccountsIcon,
        user: true,
        staff: false
    },
    {
        title: PAGES.chatbot.title,
        path: PAGES.chatbot.path,
        icon: SmartToyIcon,
        user: true,
        staff: false
    },
    {
        title: PAGES.recommended.title,
        path: PAGES.recommended.path,
        icon: RecommendIcon,
        user: true,
        staff: false,
        allow_anon: true
    },
    {
        title: PAGES.favourites.title,
        path: PAGES.favourites.path,
        icon: BookmarkIcon,
        user: true,
        staff: false
    },
    {
        title: PAGES.admin_portal.title,
        path: PAGES.admin_portal.path,
        icon: AdminPanelSettingsIcon,
        user: true,
        staff: true
    },
    {
        title: PAGES.terminology_admin.title,
        path: PAGES.terminology_admin.path,
        icon: BookIcon,
        user: true,
        staff: false,
        terminology_admin: true
    }
]

// user is null (logged out), {anon: true} (anonymous quiz session), or a full account
export const isLoggedIn = (user) => Boolean(user && !user.anon)

// single source of truth for nav visibility, shared by NavBar and MobileNav
export const routeVisible = (route, user) => {
    if (route.staff) {
        return isLoggedIn(user) && Boolean(user.staff)
    }
    if (route.terminology_admin) {
        return isLoggedIn(user) && Boolean(user.terminology_admin)
    }
    if (route.user) {
        return route.allow_anon ? user !== null : isLoggedIn(user)
    }
    return true
}

